<template>
  <div class="con">
    <div class="cons">
      <el-card class="box-card" style="height: 120px;">
        <div class="header" style="min-width: 1540px;">
          <div class="header01">
            {{detail.name}}【{{detail.title}}】
            <span style="display: flex;">
              {{detail.province}} ;{{detail.score}}分,
              <span style="margin-left: 5px;margin-right: 5px;"> 排名：{{detail.paiming}};</span>
              {{detail.group_d}}：{{detail.subject}}
            </span>
            <span style="margin-left: 5px;margin-right: 5px;"> 批次：{{detail.batch}};</span>
            <span v-if="detail.batch=='专科批'&&detail.zpaiming" style="margin-left: 5px;margin-right: 5px;"> 专科批位次：{{detail.zpaiming}};</span>

          </div>
          <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick" style="margin-left: 30px;">
            <el-tab-pane label="智能专业推荐" name="1"></el-tab-pane>
            <el-tab-pane label="按高校检索" name="2"></el-tab-pane>
            <el-tab-pane label="首次招生高校" name="3"></el-tab-pane>
            <el-tab-pane :label="`志愿单(${resultCount}/96)`" name="4"></el-tab-pane>
          </el-tabs>
          <div style="margin-left: auto;display: flex;align-items: center;">
            <el-button type="primary" size="small" @click="change_full_screen()">{{fullscreen?"退出全屏":"全屏"}}</el-button>
            <el-button type="success" size="small" @click="geren()">个人中心</el-button>
            <el-button size="small" type="primary" @click="back()">返回首页</el-button>
          </div>
        </div>

        <div class="active" style="min-width: 1120px;" v-if="activeName==1">
          <el-button size="small" type="primary" @click="$refs.majorData.show()">专业筛选</el-button>
          <el-button size="small" type="success" @click="$refs.collegeData.show()">院校筛选</el-button>
          <el-button size="small" type="warning" @click="$refs.otherData.show()">其他筛选</el-button>
          <div class="block" style="margin-left: 60px;" v-if="min_score>0 && max_score>0">
            分数区间：{{min_score}}分 - {{max_score}}分
          </div>
          <el-button size="small" class="zhineng" type="primary" @click="resetAndSearch">智能筛选</el-button>
          <el-button size="small" type="danger" @click="$refs.onekeyData.show()">一键填报</el-button>
          <div style="color: #515151;margin-left: 30px;font-size: 14px;">
            筛选出
            <span style="color: #35cd3a;font-weight: bold;">{{totalCount}}</span>
            条,已填报
            <span style="color: red;font-weight: bold;">{{tianbaoCount}}</span>
            条，当前第 {{currentPage}} 页
          </div>
        </div>

        <!--按照高校搜索-->
        <div class="active" v-if="activeName==2">
          <el-form :model="collForm" inline>
            <el-form-item label="高校：">
              <el-input placeholder="请输入高校名称" size="small" @keyup.enter.native="resetAndSearch"  v-model="collForm.collegeName"
                style="width: 150px;"></el-input>
            </el-form-item>
            <el-form-item label="专业：" label-width="80px">
              <el-input placeholder="请输入专业名称" size="small" @keyup.enter.native="resetAndSearch"  v-model="collForm.specialty_title"
                style="width: 150px;"></el-input>
            </el-form-item>
            <el-form-item label="省份：" label-width="80px">
              <el-select v-model="collForm.collegeProvince" v-if="activeName==2" placeholder="全部" clearable @change="resetAndSearch" size="small"  style="width:120px;">
                <el-option v-for="item in cityData" :key="item.title" :label="item.title" :value="item.title">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="院校属性：" label-width="100px">
               <el-select v-model="collForm.collegeNature" placeholder="全部" clearable @change="resetAndSearch"
                size="small"
                style="width: 200px">
                 <el-option label="全部" value="">全部</el-option>
                <el-option
                  v-for="item in shuxing"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="预测分：" style="margin-left: 10px;" v-if="activeName==2">
              <el-input placeholder="请输入分数" size="small" @keyup.enter.native="resetAndSearch" v-model="collForm.min_score" type="number"
                style="width: 100px;"></el-input>
                -
              <el-input placeholder="请输入分数" size="small" @keyup.enter.native="resetAndSearch" v-model="collForm.max_score" type="number"
                  style="width: 100px;"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" class="zhineng" type="primary" style="margin-left:10px;"
                @click="resetAndSearch()">检索</el-button>
              <el-button size="small" type="danger" @click="reset()">重置</el-button>
            </el-form-item>
            <el-form-item>
              <div style="color: #515151;margin-left: 30px;font-size: 14px;">
                筛选出
                <span style="color: #35cd3a;font-weight: bold;">{{totalCount}}</span>
                条,已填报
                <span style="color: red;font-weight: bold;">{{tianbaoCount}}</span>
                条，当前第 {{currentPage}} 页
              </div>
            </el-form-item>
            <el-form-item>
              <div style="font-size: 14px;color: #ffa534;margin-left: 20px;" v-if="userinfo.role==1">说明：非VIP会员仅展示部分数据。</div>
            </el-form-item>
          </el-form>
        </div>
        <div class="active" v-if="activeName==3">
          <el-form :model="collForm3" inline>
            <el-form-item label="高校：">
              <el-input placeholder="请输入高校名称" size="small" @keyup.enter.native="resetAndSearch"  v-model="collForm3.collegeName"
                style="width: 150px;"></el-input>
            </el-form-item>
            <el-form-item label="专业：" label-width="80px">
              <el-input placeholder="请输入专业名称" size="small" @keyup.enter.native="resetAndSearch"  v-model="collForm3.specialty_title"
                style="width: 150px;"></el-input>
            </el-form-item>
            <el-form-item label="省份：" label-width="80px">
              <el-select v-model="collForm3.collegeProvince" v-if="activeName==3" placeholder="全部" clearable @change="resetAndSearch" size="small"  style="width:120px;">
                <el-option v-for="item in cityData" :key="item.title" :label="item.title" :value="item.title">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="院校属性：" label-width="100px">
               <el-select v-model="collForm3.collegeNature" placeholder="全部" clearable @change="resetAndSearch"
                size="small"
                style="width: 200px">
                 <el-option label="全部" value="">全部</el-option>
                <el-option
                  v-for="item in shuxing"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
               </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" class="zhineng" type="primary" style="margin-left:10px;"
                @click="resetAndSearch()">检索</el-button>
              <el-button size="small" type="danger" @click="reset3()">重置</el-button>
            </el-form-item>
            <el-form-item>
              <div style="color: #515151;margin-left: 30px;font-size: 14px;">
                筛选出
                <span style="color: #35cd3a;font-weight: bold;">{{totalCount}}</span>
                条,已填报
                <span style="color: red;font-weight: bold;">{{tianbaoCount}}</span>
                条，当前第 {{currentPage}} 页
              </div>
            </el-form-item>
            <el-form-item>
              <div style="font-size: 14px;color: #ffa534;margin-left: 20px;" v-if="userinfo.role==1">说明：非VIP会员仅展示部分数据。</div>
            </el-form-item>
          </el-form>
        </div>

        <div class="active" v-if="activeName==4">
          <el-form :model="resultForm" inline>
            <el-form-item>
              <el-button size="small" type="warning" @click="updateIsgao()">清除高亮</el-button>
              <el-button size="small" type="danger" @click="deleteAll()">全部删除</el-button>
              <el-button type="success" size="small" @click="$refs.sortData.dialogVisible=true">专业排序</el-button>
              <el-button size="small" type="primary" @click="$refs.baogaoData.show()">浏览报告</el-button>
              <el-upload
              style="display: inline-block;margin: auto 10px;"
                action="#"
                accept=".xlsx, .xls"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="importResult"
              >
                <el-button 
                size="small"
                type="primary">导入</el-button>
              </el-upload>
              
              <el-button
                type="success"
                size="small"
                @click="exportResult()"
                >导出</el-button
              >
            </el-form-item>
            <el-form-item label="高校：" style="margin-left:50px;">
              <el-input placeholder="请输入高校名称" size="small" @keyup.enter.native="resetAndSearch" v-model="resultForm.collegeName"
                style="width: 150px;"></el-input>
            </el-form-item>
            <el-form-item label="专业：" label-width="80px">
              <el-input placeholder="请输入专业名称" size="small" @keyup.enter.native="resetAndSearch" v-model="resultForm.specialty_title"
                style="width: 150px;"></el-input>
            </el-form-item>
            <el-form-item label="省份：" label-width="80px">
              <el-select
                v-model="resultForm.collegeProvince"
                placeholder="全部"
                clearable
                @change="resetAndSearch"
                size="small"
                style="width: 120px"
              >
              <el-option label="全部" value="">全部</el-option>
                <el-option
                  v-for="item in cityData"
                  :key="item.title"
                  :label="item.title"
                  :value="item.title"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="院校属性：" label-width="100px">
               <el-select v-model="resultForm.collegeNature" placeholder="全部" clearable @change="resetAndSearch"
                size="small"
                style="width: 200px">
                              <el-option label="全部" value="">全部</el-option>
                <el-option
                  v-for="item in shuxing"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
               </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" class="zhineng" @click="resetAndSearch" type="primary"
                style="margin-left:10px;">过滤</el-button>
              <el-button size="small" type="danger" @click="reset()" style="margin-right: 20px;">重置</el-button>
              已填报<span style="color: red;">{{totalCount}}</span>条，当前第 {{currentPage}} 页
            </el-form-item>
          </el-form>
        </div>
      </el-card>

      <!--表头-->
      <div class="biaotou" :class="[activeName==2?'back002':activeName==3?'back003':activeName==4?'back004':'']">
        <div class="biaotous" v-if="activeName!=3" style="width: 68.7px;">
          序号
        </div>
        <div class="biaotous ml5" style="width: 114.5px;">
          操作
        </div>
        <div class="biaotous ml5" style="width: 1137px;">
          高校专业
        </div>
        <div class="biaotous ml5" v-if="activeName!=3" style="width: 137.4px;">
          排名
        </div>
        <div class="biaotous ml5" :style="{width:activeName==3?'175px':'90px'}">
          科目<span v-if="activeName!=3">要求</span>
        </div>
        <div class="biaotous ml5" :style="{width:activeName==3?'175px':'90px'}" v-if="activeName==3">
          计划
        </div>
        <div class="biaotous ml5" :style="{width:activeName==3?'175px':'90px'}" v-if="activeName==3">
          学制
        </div>
        <div class="biaotous ml5" :style="{width:activeName==3?'175px':'90px'}" v-if="activeName==3">
          学费
        </div>
        <div class="biaotous ml5" v-if="activeName!=3" style="width: 343.5px;background: none;flex-direction: column;">
          <div class="biaotou01">
            历史等效数据
          </div>
          <div class="biaotou02">
            <div class="b01 bb">预测{{form.ming_year || "--"}}</div>
            <div class="b02 bb">{{form.current_year || "--"}}</div>
            <div class="b02 bb">{{form.qu_year || "--"}}</div>
            <div class="b02 bb">{{form.qian_year || "--"}}</div>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%;height: 207px;"></div>

    <!--表头-->
    <!--具体数据内容-->
    <el-empty description="暂无数据" v-if="list.length==0 && !loading"></el-empty>
    <tableVue v-loading="loading" :activeName="String(activeName)" :aspid="detail.volunteer_id" :lists="list" :detail="detail" :form="form" />
    
    <!-- 加载更多和没有更多数据提示 -->
    <div v-if="list.length > 0" class="loading-more">
      <p v-if="!hasMore && totalCount > 0" class="no-more">没有更多数据了</p>
    </div>
    
    <!-- 翻页按钮 -->
    <div class="pagination-buttons" v-if="activeName!=4">
      <el-button 
        size="small" 
        type="primary" 
        class="page-btn-updown"
        @click="prevPage"
        :disabled="currentPage <= 1 || loading"
      >
        上一页
      </el-button>
      <el-button 
        size="small" 
        type="primary" 
        class="page-btn-updown"
        @click="nextPage"
        :disabled="!hasMore || loading"
      >
        下一页
      </el-button>
    </div>
    
    <!--具体数据内容-->
    <!--专业筛选-->
    <selectMajor ref="majorData" />
    <!--院校筛选-->
       <selectCollege ref="collegeData" />
    <!--其他筛选条件-->
    <selectOther ref="otherData" />

    <!--报告-->
      <baogaoVue ref="baogaoData" :list="list" />

      <!--编辑-->
      <editVue ref="editData" />
      <!--一键填报-->
      <Onekey ref="onekeyData" />
      <!--一键填报-->
    <!--专业排序-->
    <sortVue ref="sortData" :lists="newZhiyuan" />
    <!--专业排序-->
  </div>
</template>

<script>
  import {
    getUserVooluteer,
    screenFind,
    college_intell_screen,
    college_gaoxiao_screen,
    college_result_screen,
    addAll, deleteAll, updateIsgao,
    Volunteer_currentCount,
    
    clearResult,
    importResult,
    exportResult
  } from "@/api/gw/volunteer.js"
  import XLSX from "xlsx"
  import tableVue from "./table.vue";
  import selectMajor from "./components/selectMajor.vue";
  import selectCollege from "./components/selectCollege.vue";
  import selectOther from "./components/selectOther.vue";
  import baogaoVue from "./components/baogao.vue"
  import editVue from "./components/edit.vue"
  import cityJson from "@/utils/city.json"
  import sortVue from "./sort.vue"
  import {
    mapGetters
  } from "vuex"
  import Onekey from "./components/Onekey.vue"
  export default {
    components: {
      tableVue,
      selectMajor,
      selectCollege,
      selectOther,
      baogaoVue,
      editVue, Onekey,
      sortVue
    },
    data() {
      return {
        // 分页相关参数
        currentPage: 1,
        pageSize: 500, // 修改为每页500条
        totalCount: 0,
        tianbaoCount: 0,
        hasMore: true,
        
        dialog: {
          addDialogStatus: false,
          updateDialogStatus: false,
          importDialogstatus : false,
          studentDialog:false,//学生档案维护
        },
        cityData: cityJson,
        aspid: "",
        activeName: "1",
        value1: 150, //向上分数
        value2: 200, //向下分数

        //按高校检索表单
        collForm: {
          collegeName: "", //高校名称
          specialty_title: "", //专业名称
          collegeProvince: "", //省份
          min_score:"",//最低分
          max_score:"",//最高分
          lowest_mark:"",//最低分不高于
          collegeNature:""
        },
        //按高校检索表单
        collForm3: {
          collegeName: "", //高校名称
          specialty_title: "", //专业名称
          collegeProvince: "", //省份
          min_score:"",//最低分
          max_score:"",//最高分
          lowest_mark:"",//最低分不高于
          collegeNature:""
        },
        collForms: {
          collegeName: "", //高校名称
          specialty_title: "", //专业名称
          collegeProvince: "", //省份
          collegeNature:"",//院校属性
        },
        resultForm: {
          collegeName: "",
          specialty_title: "",
          collegeNature:"",
          collegeProvince:""
        },

        batch:"",
        loading: false,

        importConfig: {
          remote: true,
          importMethod: this.importResult,
          types:['xlsx', 'xls'],
          modes: ['insert'],
        },
        import_page: 1,
        import_limit: 100,
        import_percent: 0,

        list: [],
        form: {}, //配置文件

        detail: {}, //详情
        resultCount: 0,

        min_score:0,//最低分
        max_score:0,//最高分


        newZhiyuan:[],
        fullscreen:false,
        shuxing:[
          "公办",
          "民办",
          "独立学院",
          "解放军院校",
          "内地与港澳台地区合作办学",
          "中外合作办学",
        ],
      }
    },
    watch: {
      activeName(e) {
        // 切换标签时重置分页
        this.resetPagination();
      },
      list(e){
        if(!this.resultForm.collegeName && !this.resultForm.specialty_title){
          this.list.forEach((r,j)=>{
            r.sort_id = j+1
          })
        }
        if(this.activeName!=4){
          this.list.forEach((r,j)=>{
            r.sort_id = j+1
          })
        }
      }
    },
    computed: {
      ...mapGetters(['isLogin', "userinfo"]),
      ...mapGetters(['batchValue',"batchValue"]),
    },
    mounted() {
      let that = this;
      this.$store.dispatch("getUserInfo").then(() => {
        if(this.$route.query.n){
          this.activeName = String(this.$route.query.n)
        }
        console.log(this.batchValue);
        that.getUserVooluteer(); //获取自己的志愿填报列表
      })
    },
    methods: {
      // 重置分页参数
      resetPagination() {
        this.currentPage = 1;
        this.totalCount = 0;
        this.tianbaoCount = 0;
        this.hasMore = true;
        this.list = [];
      },
      
      // 上一页
      prevPage() {
        if (this.currentPage <= 1 || this.loading) return;
        
        this.currentPage--;
        
        // 根据当前激活的标签页调用对应的接口
        if (this.activeName == 1) {
          this.zhinengshai();
        } else if (this.activeName == 2 || this.activeName == 3) {
          this.gaoxiaoFind();
        } else if (this.activeName == 4) {
          this.college_result_screen();
        }
      },
      
      // 下一页
      nextPage() {
        if (!this.hasMore || this.loading) return;
        
        this.currentPage++;
        
        // 根据当前激活的标签页调用对应的接口
        if (this.activeName == 1) {
          this.zhinengshai();
        } else if (this.activeName == 2 || this.activeName == 3) {
          this.gaoxiaoFind();
        } else if (this.activeName == 4) {
          this.college_result_screen();
        }
      },
      
      // 重置并搜索（重新从第一页加载）
      resetAndSearch() {
        this.resetPagination();
        
        if (this.activeName == 1) {
          this.screenFind();
        } else if (this.activeName == 2 || this.activeName == 3) {
          this.gaoxiaoFind();
        } else if (this.activeName == 4) {
          this.college_result_screen();
        }
      },
      
      exportResult(){
        const loading = this.$loading({
          lock: true,
          text: '导出中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
          });
        exportResult({aspid:this.detail.volunteer_id}).then(res=>{
            let a = document.createElement("a");
            a.href = res.data.file;
            a.download = res.data.filename;
            a.click();
            URL.revokeObjectURL(a.href);
        }).finally(()=>{
          loading.close();
        })
      },
      importResult(file){
        let that = this;
        let file1 = null;
        if(file.raw){
          file1 = file.raw;
        }else{
          file1 = file;
        }
        const loading = this.$loading({
          lock: true,
          text: '操作中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
          });
          var excelData = []
          const fileReader = new FileReader()
          fileReader.onload = (ev) => {
            try{
              const data = ev.target.result
              const workbook = XLSX.read(data, { type: "binary" })
              Object.keys(workbook.Sheets).forEach((sheet) => {
                excelData.push(
                  ...XLSX.utils.sheet_to_json(workbook.Sheets[sheet])
                )
              })
              this.dialog.importDialogstatus = true
              this.import_percent = 0
              this.import_page = 1
              clearResult({aspid:that.detail.volunteer_id}).then(res => {
                that.partPost(excelData);
              });
            }catch(e){
              console.log(e);
              this.$message.danger('文件类型不正确')
            }
          }
          fileReader.readAsBinaryString(file1)
          loading.close();
      },
      partPost(data){
        let perdata = []
        for(let i=(this.import_page-1)*this.import_limit; i<this.import_page*this.import_limit; i++){
          if(data[i]){
            perdata.push(data[i])
          }
        }
        for(let i = 0;i<perdata.length;i++){
          perdata[i].aspid = this.detail.volunteer_id;
        }
        console.log(perdata);
        let total_page = Math.ceil(data.length / this.import_limit)
        this.import_percent = Math.ceil(this.import_page * 100 / total_page)
        this.loading = true
        importResult(perdata).then(res => {
          if(res.status == 200){
            if(this.import_page <= total_page-1){
              this.import_page = this.import_page +1
              this.partPost(data)
            }else{
              this.dialog.importDialogstatus = false;
              this.$message({message: '导入完成', type: 'success'})
              if (this.activeName == 4) {
                this.resetAndSearch();
                this.Volunteer_currentCount();
              }
              this.loading = false
            }
          }
        })
      },
      handleTabClick(e) {
        // 标签点击时加载对应数据
        this.resetAndSearch();
      },
      change_full_screen(){
            //全屏切换函数
            let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen; //判断全屏状态
    },
      geren(){
        this.$router.push({
          path:"/Home"
        })
      },
      tianbaot(){
        let list = [...this.list];
        let a = list.filter(r=>{
          return r.is_result;
        })
        return a.length;
      },
      Volunteer_currentCount(){
        Volunteer_currentCount({
          aspid:this.detail.volunteer_id
        }).then(res=>{
          this.resultCount = res.data.count
        })
      },
      //编辑
      edit(){
        this.$refs.editData.show();
      },
      back(){
        this.$router.push({
          path:"/"
        })
      },
      //智能筛选
      zhinengshai(showLoading = true) {
        if (showLoading) {
          this.loading = true;
        }
        
        college_intell_screen({
          aspid: this.detail.volunteer_id,
          up_score: this.value1,
          down_score: this.value2,
          page: this.currentPage,
          pageSize: this.pageSize // 添加pageSize参数
        }).then(res => {
          console.log("智能专业推荐", res.data);
          
          // 替换当前页数据
          this.list = res.data.list;
          
          this.form = res.data.object;
          this.min_score = res.data.min_score || 0;
          this.max_score = res.data.max_score || 0;
          this.totalCount = res.data.count || 0;
          this.tianbaoCount = res.data.tianbaocount || 0;
          
          // 判断是否还有更多数据
          this.hasMore = this.currentPage * this.pageSize < this.totalCount;
        }).finally(() => {
          this.loading = false;
          this.Volunteer_currentCount();
        })
      },
      //高校筛选
      gaoxiaoFind(showLoading = true) {
        if (showLoading) {
          this.loading = true;
        }
        
        let form = {};
        if(this.activeName==2){
          form = this.collForm;
          form["shouciZhao"] = "";
        }else{
          form = this.collForm3;
          form["shouciZhao"] = "是";
        }
        
        form["aspid"] = this.detail.volunteer_id;
        form["page"] = this.currentPage;
        form["pageSize"] = this.pageSize; // 添加pageSize参数
        
        console.log(this.activeName, form);
        
        college_gaoxiao_screen(form).then(res => {
          console.log("高校", res.data);
          
          // 替换当前页数据
          this.list = res.data.list;
          
          this.form = res.data.object;
          this.totalCount = res.data.count || 0;
          this.tianbaoCount = res.data.tianbaocount || 0;
          
          // 判断是否还有更多数据
          this.hasMore = this.currentPage * this.pageSize < this.totalCount;
        }).finally(() => {
          this.loading = false;
          this.Volunteer_currentCount();
        })
      },
      resets() {
        this.resultForm = {
          collegeName: "",
          specialty_title: "",
        };
      },
      //查看结果
      college_result_screen(showLoading = true) {
        if (showLoading) {
          this.loading = true;
        }
        
        this.resultForm["aspid"] = this.detail.volunteer_id;
        this.resultForm["page"] = this.currentPage;
        this.resultForm["pageSize"] = this.pageSize; // 添加pageSize参数
        
        college_result_screen(this.resultForm).then(res => {
          console.log("结果", res.data);
          
          // 替换当前页数据
          this.list = res.data.list;
          this.newZhiyuan = res.data.list;
          
          this.form = res.data.object;
          this.totalCount = res.data.count || 0;
          
          // 为新添加的项目设置checkd属性
          this.list.forEach(r => {
            if (r.checkd === undefined) {
              this.$set(r, "checkd", false);
            }
          });
          
          // 判断是否还有更多数据
          this.hasMore = this.currentPage * this.pageSize < this.totalCount;
        }).finally(() => {
          this.loading = false;
          this.Volunteer_currentCount();
        })
      },
      //通过名称和专业从数组中进行筛选
      collegeSearch() {
        let list = this.newZhiyuan;
        let collegeName = this.resultForm.collegeName;
        let specialty_title = this.resultForm.specialty_title;
        let collegeProvince = this.resultForm.collegeProvince;//省份
        let collegeNature = this.resultForm.collegeNature;
        
        this.list = this.filterUniversities(collegeName, specialty_title, collegeProvince, collegeNature, list);
      },
      filterUniversities(collegeName, specialtyTitle, collegeProvince, collegeNature, list) {
         // 使用数组的filter方法筛选出符合条件的项
          return list.filter(item => {
              // 对于每个筛选条件，如果对应的参数为空或未定义，则跳过该条件检查
              // 否则，检查该项的属性是否包含指定的值（不区分大小写）
              return (
                  (!collegeName || item.collegeName.toLowerCase().includes(collegeName.toLowerCase())) &&
                  (!specialtyTitle || item.specialty_title.toLowerCase().includes(specialtyTitle.toLowerCase())) &&
                  (!collegeProvince || item.collegeProvince.toLowerCase().includes(collegeProvince.toLowerCase())) &&
                  (!collegeNature || item.collegeNature.toLowerCase().includes(collegeNature.toLowerCase()))
              );
          });
      },
      //刷新数据
      yichuList(){
        this.resetAndSearch();
      },
      //清除高亮
      updateIsgao(){
        updateIsgao({
          volunteer_id:this.detail.volunteer_id
        }).then(()=>{
          this.$notify({
          title: '成功',
          message: '',
          type: 'success'
        });
          this.resetAndSearch();
        })
      },
      //获取筛选条件
      screenFind() {
        screenFind({
          aspid: this.detail.volunteer_id
        }).then(res => {
          console.log("筛选条件", res.data);
          if (res.data) {
            console.log("筛选条件具体数据", JSON.parse(res.data.other_screen));
          }
          this.zhinengshai();
        })
      },
      //获取志愿填报列表
      getUserVooluteer() {
        this.loading = false;
        getUserVooluteer({}).then(res => {
          console.log("志愿填报自己信息", res);
          if (res.data) {
            this.detail = res.data;
            this.batch = res.data.batch;
            
            //存在则请求学校
            this.resetAndSearch();
            this.Volunteer_currentCount();//获取填报的数量
          } else {
            this.$message.error("您当前没有志愿单，请返回首页创建");
            this.$router.push({
              path: "/"
            })
          }
        }).finally(() => {
          this.loading = false;
        })
      },
      //重置
      reset(){
        this.collForm = {
          collegeName:"",//高校名称
          specialty_title:"",//专业名称
          collegeProvince:"",//省份
          collegeCity:"",//城市
          lowest_mark:"",//最低分不高于
          collegeNature:""
        };
        this.collForms= {
          collegeName: "", //高校名称
          specialty_title: "", //专业名称
          collegeProvince: "", //省份
          collegeNature:"",//院校属性
        };
        this.resultForm={
          collegeName: "",
          specialty_title: "",
          collegeNature:"",
          collegeProvince:""
        };
        
        this.resetAndSearch();
      },
      //重置
      reset3(){
        this.collForm3 = {
          collegeName:"",//高校名称
          specialty_title:"",//专业名称
          collegeProvince:"",//省份
          collegeCity:"",//城市
          lowest_mark:"",//最低分不高于
          collegeNature:""
        };
        
        this.resetAndSearch();
      },
      //全部删除
      deleteAll(){
        this.$confirm('您真的要将所有选好的志愿全部删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
          }).then(()=>{
            const loading = this.$loading({
            lock: true,
            text: '删除中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
            });
            deleteAll({aspid:this.detail.volunteer_id}).then(res=>{
              this.$notify({
                title: '删除成功',
                message: '',
                duration:2000,
                type: 'success'
            });
              this.resetAndSearch();
            }).finally(()=>{
              loading.close();
            })
          })
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import './scss/framework.scss';

  .back002 {

    .biaotous,
    .biaotou01,
    .bb {
      background: #716aca !important;
    }
  }

  .back003 {

    .biaotous,
    .biaotou01,
    .bb {
      background: lightslategrey !important;
    }
  }

  .back004 {

    .biaotous,
    .biaotou01,
    .bb {
      background: #ffa534 !important;
    }
  }

  .biaotou {
    width: 100%;
    height: 60px;
    margin-top: 5px;
    display: flex;

    .row {
      display: flex;
      flex-wrap: wrap;
    }
  }

  .h-100 {
    height: 100%;
  }

  .zhineng {
    background: #716aca !important;
    background-color: #716aca !important;
    border: 1px solid #716aca !important;
    margin-left: 60px;
  }

  .block {
    display: flex;
    align-items: center;
    margin-left: 30px;

    .demonstration {
      font-weight: bold;
      font-size: 12px;
    }

    .el-slider {
      width: 180px !important;
      margin-left: 10px;
    }

    .el-slider__bar {
      background-color: #ed5565 !important;
    }
  }

  .active {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .header {
    width: 100%;
    display: flex;
    align-items: center;

    .header01 {
      display: flex;
      align-items: flex-end;
      font-size: 20px;

      span {
        font-size: 14px;
        margin-left: 20px;
      }
    }
  }

  .con {
    width: 100%;
    height: 100vh;
    background: #eee !important;

    .cons {
      width: 100%;
      margin: 0 auto;
      height: 200px;
      position: fixed;
      z-index: 1030;
      left: 0px;
      top: 0px;
      background: #eee !important;
    }
  }
  
  // 加载更多样式
  .loading-more {
    text-align: center;
    padding: 20px;
    color: #666;
  }
  
  .no-more {
    color: #999;
    margin: 0;
  }
  
  // 分页按钮样式
  .pagination-buttons {
    position: fixed;
    bottom: 100px;
    right: 50px;
    display: flex;
    flex-direction: column;
  }
  
  .page-btn-updown{
    font-size: 18px;
    font-family: monospace;
    font-weight: 900;
    color: black;
    opacity: 0.8;
    margin-bottom: 10px;
    margin-left: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/volunteer/index.vue